import { useSyncExternalStore } from 'react';
import { loadingStore } from './loadingStore';

export function useLoadingCount() {
  return useSyncExternalStore(loadingStore.subscribe, loadingStore.getSnapshot, loadingStore.getSnapshot);
}

